import React from 'react';
import './Team.css';

const Team = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Anwar Naha',
      position: 'Chairman',
      description:
        'P.K. Anwar Naha, the Managing Director of Abdul Jaleel Marine Spares LLC, epitomizes the convergence of philanthropy and business. A staunch believer in the transformative power of education, he seamlessly integrates his industrialist role with social work commitment.',
      image: '/assets/img/team/Team-1.jpg',
    },
    {
      id: 2,
      name: 'Dr. Hamad Al Hosani',
      position: 'President',
      description:
        'Dr. Hamad Al Hosani is a highly accomplished healthcare executive with over 20 years of experience. He currently holds the position of CEO – International Partnerships at Burjeel Holdings, focusing on strategic global alliances and healthcare innovation.',
      image: '/assets/img/team/Team-2.jpg',
    },
    {
      id: 3,
      name: 'Mohammed Ashraf',
      position: 'Founder & Managing Director',
      description:
        'A graduate in Commerce with a postgraduate degree in Business Administration from Cardiff Metropolitan University, UK. Since 2012, he has played a pivotal role in the education sector, specializing in abroad education.',
      image: '/assets/img/team/Team-3.jpg',
    },
    {
      id: 4,
      name: 'Harish Avethan',
      position: 'Director & CEO',
      description:
        'A seasoned professional with strong background in engineering and business administration. His extensive experience includes key roles at ONGC as Plant Engineer and at Midet College of Engineering as Vice Principal.',
      image: '/assets/img/team/Team-4.jpg',
    },
    {
      id: 5,
      name: 'Dr. Asif Theyyampattil',
      position: 'Director',
      description:
        'A serial entrepreneur turned consultant with Post Graduate in Business Administration. Completed certifications from Harvard University, IIM-Bangalore, and Waseda University-Tokyo. Active consultant at ATBC since 2014.',
      image: '/assets/img/team/Team-5.jpg',
    },
    {
      id: 6,
      name: 'Mohamed Izmir K',
      position: 'Director',
      description:
        'A dynamic business regeneration expert with Bachelor of Business Marketing from Swinburne University, Australia. Owner & CEO of Starling Eye GPS Trading LLC and Executive Director of EAT & DRINK group.',
      image: '/assets/img/team/Team-6.jpg',
    },
    {
      id: 7,
      name: 'Shahir Shahul Hameed',
      position: 'Director',
      description:
        'A uniquely qualified leader combining technical foundation as Biomedical Engineer with MBA from UWIC, Cardiff, UK. Managing Partner of LedgerLink Accounts and Green Oasis Medical Equipment Trading Company.',
      image: '/assets/img/team/Team-7.jpg',
    },
  ];

  return (
    <div className='team'>
      <div className='team-container'>
        <div className='team-header'>
          <h1>Meet Our Team</h1>
          <p>Dedicated professionals committed to your success</p>
        </div>

        <div className='team-grid'>
          {teamMembers.map((member, index) => (
            <div
              key={member.id}
              className='team-card'
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className='member-image'>
                {member.image ? (
                  <img
                    src={member.image}
                    alt={member.name}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : null}
                <div
                  className='image-placeholder'
                  style={{ display: member.image ? 'none' : 'flex' }}
                >
                  <span>
                    {member.name
                      .split(' ')
                      .map((n) => n[0])
                      .join('')}
                  </span>
                </div>
              </div>

              <div className='member-info'>
                <h3>{member.name}</h3>
                <h4>{member.position}</h4>
                <p>{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
